<template>
  <div id="wrapper">

    <div class="normalheader ">
      <div class="hpanel">
        <div class="panel-body">
          <div id="hbreadcrumb" class="pull-right m-t-lg">
            <ol class="hbreadcrumb breadcrumb">
              <li><router-link :to="{name: 'Dashboard'}">Dashboard</router-link></li>
              <li class="active">
                <span>Manage Profiles</span>
              </li>
            </ol>
          </div>
          <h3 class="font-light m-b-xs">
            Manage Profiles
          </h3>
          <small>You can manage all profiles</small>
        </div>
      </div>
    </div>

    <div class="content">

      <div class="row">
        <div class="col-lg-12">
          <div class="hpanel">

            <div class="panel-heading">
              Profiles
            </div>

            <div class="panel-body">
              <table id="userTable" class="table table-striped table-bordered table-hover" width="100%" style="font-size: 10px">
                <thead>
                <tr>
                  <th>Name</th>
                  <th>Logo</th>
                  <th>Link logo</th>
                  <th>Expert Color</th>
                  <th>Nb simultaneous Access</th>
                  <th>Individual Plans Exception List</th>
                  <th>Actions</th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(profile , key) in profiles" :key="key">
                  <td style="vertical-align: middle;">
                    <router-link class="" :to="{name: 'PreviewProfile', params: {id: profile.id}}">
                      {{profile.name}}
                    </router-link>
                  </td>
                  <td class="text-center"><img :src="api_url + profile.logo" style="max-width: 180px"></td>
                  <td style="vertical-align: middle;">{{profile.logo_link}}</td>
                  <td style="vertical-align: middle;">{{profile.expert_color}}</td>
                  <td style="vertical-align: middle;">{{profile.nb_simultaneous_access}}</td>
                  <td style="vertical-align: middle;">{{profile.individual_plans_exception_list}}</td>
                  <td style="vertical-align: middle;" class="text-center">
                    <router-link class="btn btn-xs btn-outline btn-info" :to="{name: 'PreviewProfile', params: {id: profile.id}}">
                      <i class="fas fa-pencil-alt"></i> Open
                    </router-link>
                    <router-link class="btn btn-xs btn-outline btn-warning" :to="{name: 'EditProfile', params: {id: profile.id}}">
                      <i class="fas fa-pencil-alt"></i> Edit
                    </router-link>
                  </td>
                </tr>
                </tbody>
              </table>

            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>

import axios from 'axios'

export default {
  components: {},
  name: 'ProfilesList',
  methods: {
    getResources: function () {
      this.getProfiles()
    },
    getProfiles: function () {
      axios.get('/profiles').then((response) => {
        this.profiles = response.data
      })
    }
  },
  data () {
    return {
      api_url: process.env.API_URL,
      profiles: []
    }
  },
  beforeMount () {
    this.getResources()
  }
}

</script>



// WEBPACK FOOTER //
// src/pages/manageProfiles/ProfilesList.vue